module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"hints":{"kpi_indicator":"Ключевой индикатор"}},"kz":{"hints":{"kpi_indicator":"Кілттік көрсеткіш"}}}')
  delete Component.options._Ctor
}
